import _ from "lodash";
import {LOGO_IMAGE_DETAIL} from "../constants/shopify.constant";

export {
    prepareShopifyBlogArticle,
    prepareCreatedArticleDetail,
}

const prepareShopifyBlogArticle = (blogPost, blogPostContent, imageBase64Data) => {
    const metaLinesMap = _.keyBy(blogPostContent.metaLines, 'metaType');

    const article: any = {
        author: 'Parri Ganesan V P',
        title: blogPost.title,
        blog_id: blogPost.shopifyBlogId,
        body_html: blogPostContent.htmlContent,
        summary_html: metaLinesMap['excerpts'].text,
        tags: metaLinesMap['tags'].text,
        published_at: new Date().toISOString(),
    };

    if (blogPost.status === 'Published' && blogPost.shopifyArticle && blogPost.shopifyArticle.id) {
        article.id = blogPost.shopifyArticle.id;
    }

    if (imageBase64Data) {
        article.image = {
            attachment: _.replace(imageBase64Data, /^data:image\/\w+;base64,/, ""),
            alt: blogPost.title
        }
    }

    return article;
}

const prepareCreatedArticleDetail = (createdArticle) => {
    return {
        id: createdArticle.id,
        shopifyArticleId: createdArticle.admin_graphql_api_id,
        title: createdArticle.title,
        handle: createdArticle.handle,
        author: createdArticle.author,
        user_id: createdArticle.user_id,
        blog_id: createdArticle.user_id,
        created_at: createdArticle.created_at,
        published_at: createdArticle.published_at,
        updated_at: createdArticle.updated_at,
    }
}
